import { ArrowLeft } from 'components/HelperDocuments/icons';
import { ItemTypes } from 'components/forms/ui/DocumentStation/ItemTypes';
import React, { useEffect, useState, useRef } from 'react';
import { useDrag } from 'react-dnd';

const scrollButton: React.CSSProperties = {
  position: 'fixed',
  cursor: 'move',
  zIndex: 5000,
  width: 40,
  height: 40,
  borderRadius: 5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f7f7f9',
};

export default function ScrollButton() {
  const [left, setLeft] = useState<number>(window.innerWidth);
  const [top, setTop] = useState<number>(window.innerHeight - 45);
  const hasBeenDragged = useRef<boolean>(false);

  useEffect(() => {
    const updateViewportAndPosition = () => {
      if (!hasBeenDragged.current) {
        setLeft(window.innerWidth - 65);
        setTop(window.innerHeight - 45);
      }
    };

    window.addEventListener('resize', updateViewportAndPosition);

    updateViewportAndPosition();

    return () => window.removeEventListener('resize', updateViewportAndPosition);
  }, []);

  const [{ opacity }, dragRef] = useDrag(
    () => ({
      type: ItemTypes.CARD,
      item: { id: 'ScrollTop' },
      collect: monitor => ({
        opacity: monitor.isDragging() ? 0 : 1,
        drag: monitor.getHandlerId(),
      }),
      options: { dropEffect: 'move' },
      end: (_, monitor) => {
        const coordinates = monitor.getSourceClientOffset();
        if (coordinates) {
          setLeft(coordinates.x);
          setTop(coordinates.y);
          hasBeenDragged.current = true; // Mark as manually positioned
        }
      },
    }),
    []
  );

  const isDragging = opacity === 0;

  return (
    <div
      id="ScrollTop"
      ref={dragRef}
      style={{ ...scrollButton, top, left, opacity: isDragging ? 0 : 1 }}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <ArrowLeft style={{ transform: 'rotate(90deg)' }} />
    </div>
  );
}
